import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { MEM_HAN_Schema } from './MEM_HAN_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(MEM_HAN_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Member', 'getMemBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Member.getMemBasicR1, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
// 부서 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(MEM_HAN_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.Utility.getDepLast, params);
  }, successOptions);
};

export const useSearch3 = (options = {}) => {
  const { onSuccess } = options;

  const params = {};

  const query = useQuery({
    queryKey: ['Utility', 'getAuthInfo', params],
    queryFn: () => apiRequest('post', Global.urls.Utility.getAuthInfo, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: (rows) => {
        const formattedList = rows.map((item) => ({
          name: item.codeNm,
          value: item.authCd,
        }));

        onSuccess?.(formattedList);
      },
    });
  }, [query.isSuccess, query.data]);

  return query;
};

export const useSearch4 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(MEM_HAN_Schema.mapper.search3);

  const query = useQuery({
    queryKey: ['Member', 'getMemBasicR3', params],
    queryFn: () => apiRequest('post', Global.urls.Member.getMemBasicR3, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    const res = query.data;
    if (!res?.isSuccess) return;

    onSuccess?.(res.data?.[0]);
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch5 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(MEM_HAN_Schema.mapper.search4);

  const query = useQuery({
    queryKey: ['Member', 'getMemBasicR4', params],
    queryFn: () => apiRequest('post', Global.urls.Member.getMemBasicR4, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    const res = query.data;
    if (!res?.isSuccess) return;

    // 배열로 반환 (빈 배열일 수 있음)
    const data = Array.isArray(res.data)
      ? res.data
      : res.data
        ? [res.data]
        : [];
    onSuccess?.(data);
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch6 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(MEM_HAN_Schema.mapper.search5, context);
    return apiRequest('post', Global.urls.Plant.getPlaBasicR1, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save1, {
      companyInfo: options.companyInfo ?? [],
      authCodeList: options.authCodeList ?? [],

      getProperName: ({ userInfo, search, companyInfo }) => {
        const coCd =
          userInfo?.authCd === 'ADMIN' ? search?.coCd : userInfo?.coCd;

        if (userInfo?.authCd === 'ADMIN') {
          const selected = (companyInfo ?? []).find((c) => c.coCd === coCd);
          return selected?.properName || '';
        }
        return userInfo?.properName || '';
      },

      getAuthCd: (authNm, { authCodeList }) => {
        const name = authNm || '기본';
        return (authCodeList ?? []).find((f) => f.name === name)?.value || '';
      },
    });

    return apiRequest('post1', Global.urls.Member.saveMemBasicU1, payload);
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save2);

    return apiRequest('post1', Global.urls.Member.savePlaBasicU2, payload);
  }, options);
};

export const useSave3 = (options = {}) => {
  return useSaveMutation(async ({ rows, approve }) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save3, {
      approve,
    });

    return apiRequest('post1', Global.urls.Member.saveMemBasicU3, payload);
  }, options);
};
export const useSave4 = (options = {}) => {
  return useSaveMutation(async (rows, context) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save4, {
      context,
    });

    return apiRequest('post1', Global.urls.Member.saveMemBasicU4, payload);
  }, options);
};
export const useSave5 = (options = {}) => {
  return useSaveMutation(async (rows, context) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save5, {
      context,
    });

    return apiRequest('post1', Global.urls.Member.saveMemBasicU5, payload);
  }, options);
};

export const useSave6 = (options = {}) => {
  return useSaveMutation(async ({ rows }) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.save6);

    return apiRequest('post1', Global.urls.Member.saveMemBasicU6, payload);
  }, options);
};
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEM_HAN_Schema.mapper.delete1);

    return apiRequest('post1', Global.urls.Member.deleteMemBasicD1, payload);
  }, options);
};
